import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { IAttachment, IDeleteEntity, IGenericResponse } from '../../shared';
import { TimeCardDocumentation } from './time-card-documentation.model';

export const loadTimeCardDocumentations = createAction(
    '[TimeCardDocumentation/API] Load TimeCardDocumentations',
    props<{ timeCardDocumentations: TimeCardDocumentation[] }>()
);

export const addTimeCardDocumentation = createAction(
    '[TimeCardDocumentation/API] Add TimeCardDocumentation',
    props<{ timeCardDocumentation: TimeCardDocumentation }>()
);

export const upsertTimeCardDocumentation = createAction(
    '[TimeCardDocumentation/API] Upsert TimeCardDocumentation',
    props<{ timeCardDocumentation: TimeCardDocumentation }>()
);

export const addTimeCardDocumentations = createAction(
    '[TimeCardDocumentation/API] Add TimeCardDocumentations',
    props<{ timeCardDocumentations: TimeCardDocumentation[] }>()
);

export const upsertTimeCardDocumentations = createAction(
    '[TimeCardDocumentation/API] Upsert TimeCardDocumentations',
    props<{ timeCardDocumentations: TimeCardDocumentation[] }>()
);

export const updateTimeCardDocumentation = createAction(
    '[TimeCardDocumentation/API] Update TimeCardDocumentation',
    props<{ timeCardDocumentation: Update<TimeCardDocumentation> }>()
);

export const updateTimeCardDocumentations = createAction(
    '[TimeCardDocumentation/API] Update TimeCardDocumentations',
    props<{ timeCardDocumentations: Update<TimeCardDocumentation>[] }>()
);

export const deleteTimeCardDocumentation = createAction(
    '[TimeCardDocumentation/API] Delete TimeCardDocumentation',
    props<{ id: number | string }>()
);

export const deleteTimeCardDocumentations = createAction(
    '[TimeCardDocumentation/API] Delete TimeCardDocumentations',
    props<{ ids: Array<number | string> }>()
);

export const clearTimeCardDocumentations = createAction(
    '[TimeCardDocumentation/API] Clear TimeCardDocumentations'
);

export const getTimecardDocumentations = createAction(
    '[TimecardDocumentation/API] Get TimecardDocumentations',
    props<{ id: string; processId: number }>()
);

export const putTimecardDocumentation = createAction(
    '[TimecardDocumentation/API] Put TimecardDocumentations',
    props<{ doc: Array<Partial<TimeCardDocumentation>> }>()
);

export const putTimecardDocumentationFailure = createAction(
    '[TimecardDocumentation/API] Put TimecardDocumentationFailure',
    props<{ error: IGenericResponse<Partial<TimeCardDocumentation>> }>()
);
export const removeTimecardDocumentation = createAction(
    '[TimecardDocumentation/API] Remove TimecardDocumentations',
    props<{ ids: Array<number | string> }>()
);
export const removeTimecardDocumentationFailure = createAction(
    '[TimecardDocumentation/API] Remove TimecardDocumentationFailure',
    props<{ error: IGenericResponse<IDeleteEntity> }>()
);
export const addTimecardDocumentationAttachment = createAction(
    '[TimecardDocumentation/API] Add TimecardDocumentation Attachment',
    props<{
        process: string;
        entityId: string;
        fileId: string;
        meta: File;
        file: string;
    }>()
);
export const addTimecardDocumentationAttachmentFailure = createAction(
    '[TimecardDocumentation/API] Add TimecardDocumentation Attachment Failure',
    props<{ res: IGenericResponse<IAttachment> }>()
);
export const addTimecardDocumentationAttachmentSuccess = createAction(
    '[TimecardDocumentation/API] Add TimecardDocumentation Attachment Success',
    props<{ res: IGenericResponse<IAttachment> }>()
);
export const removeTimecardDocumentationAttachment = createAction(
    '[TimecardDocumentation/API] Remove TimecardDocumentation Attachment',
    props<{ fileId: string }>()
);
export const removeTimecardDocumentationAttachmentSuccess = createAction(
    '[TimecardDocumentation/API] Remove TimecardDocumentation Attachment Success',
    props<{ fileId: string }>()
);
export const removeTimecardDocumentationAttachmentFailure = createAction(
    '[TimecardDocumentation/API] Remove TimecardDocumentation Attachment Failure',
    props<{ error: IGenericResponse<IAttachment> }>()
);

export const updateTimecardDocumentationSuccess = createAction(
    '[TimecardDocumentation/API] Update TimecardDocumentation Success Event',
    props<{ doc: Partial<TimeCardDocumentation> }>()
);
